import { Component, input } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

interface EstateDetailTableData {
  realTotal: string;
  personalTotal: string;
  estateTotal: string;
}

@Component({
  selector: 'app-estate-detail-table',
  templateUrl: './estate-detail-table.component.html',
  imports: [CurrencyPipe],
  providers: [CurrencyPipe],
})
export class EstateDetailTableComponent {
  data = input.required<EstateDetailTableData>();
}
